export const ItemValueTypeEnum = {
  SimpleText: 0,
  RichText: 1,
  Boolean: 2,
  SingleSelect: 3,
  MultiSelect: 4
}

export default ItemValueTypeEnum
